import React from 'react';
import ReactDOM from 'react-dom/client';
import Admin from './Admin';
import reportWebVitals from "./reportWebVitals";
import './fonts/NunitoSans.ttf';
import './i18n';
import {GlobalContextProvider} from "./contexts/globalContext";
import Customizer from "./Customizer";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

const isAdmin = window.location.href.includes('admin/plugin')

root.render(
  <React.StrictMode>
      <GlobalContextProvider>
          {isAdmin
              ? <Admin/>
              : <Customizer/>
          }
      </GlobalContextProvider>
  </React.StrictMode>
);

reportWebVitals();
